import { Variant } from "lib/enum";
import { RouteData } from "routes";
import * as businessObjType from "enums/businessObjType";
import { BusinessObj } from "auth";
import * as opt from "lib/opt";
import * as appPath from "enums/appPath";
import { DashboardComponent, UploadComponent } from "pages";
import * as enm from "lib/enum";
import { DownloadPage } from "pages";
import { UserManagement as UserManagementComponent } from "pages/Users/UserManagement";
import { EmailNotificationSettings } from "pages/EmailNotificationSettings";
import { MCCAccessContactInfoPage } from "pages";
import { Permissions } from "pages/Permissions";
import {
	OBJECT_ID_CREATE_CONTAINMENT,
	OBJECT_ID_MANAGE_USER,
	
} from "pages/Users/constants";
export interface IAppRoute {
	Upload: RouteData;
	Dashboard: RouteData;
	Download: RouteData;
	UserManagement: RouteData;
	EmailNotificationSettings: RouteData;
	MCCAccessContactInfo: RouteData;
	Permissions: RouteData;
}

export class AppRoute extends Variant<IAppRoute> {
	static Upload(data: RouteData) {
		return AppRoute.New("Upload", data);
	}
	static Dashboard(data: RouteData) {
		return AppRoute.New("Dashboard", data);
	}

	static Download(data: RouteData) {
		return AppRoute.New("Download", data);
	}
	static UserManagement(data: RouteData) {
		return AppRoute.New("UserManagement", data);
	}
	static EmailNotificationSettings(data: RouteData) {
		return AppRoute.New("EmailNotificationSettings", data);
	}
	static MCCAccessContactInfo(data: RouteData) {
		return AppRoute.New("MCCAccessContactInfo", data);
	}
	static Permissions(data: RouteData) {
		return AppRoute.New("Permissions", data);
	}
	get Name() {
		return this.Tag;
	}
	get Path(): string {
		// For route matching purposes, we want to get the base path without parameters
		// Example: "/download/:id" should become "/download"
		const segments = this.FullPath.Split("/");
		// filter out parameter segments (start with :)
		const baseSegments = segments.Filter((s) => !s.HasPrefix(":"));

		let basePath = baseSegments.Join("/");
		//ensure basepath starts with /
		if (!basePath.HasPrefix("/") && !basePath.IsEmpty()) {
			basePath = "/" + basePath;
		}

		return basePath || "/";
	}
	PathWithParams(...params: string[]): string {
		return fmt.Sprintf(
			"%v/%v",
			this.Path,
			params.Map((p) => (p.HasPrefix("/") ? p.Skip(1) : p)).Join("/")
		);
	}
	get FullPath(): string {
		return this.Data.path.Path();
	}

	BusinessObjType(): businessObjType.BusinessObjType {
		return this.Data.id;
	}

	SetBuisnessObj(buisnessObj: BusinessObj): AppRoute {
		return this.Match({
			Dashboard: (d) =>
				AppRoute.Dashboard({ ...d, businessObj: buisnessObj }),
			Upload: (u) => AppRoute.Upload({ ...u, businessObj: buisnessObj }),
			Download: (d) =>
				AppRoute.Download({ ...d, businessObj: buisnessObj }),
			UserManagement: (u) =>
				AppRoute.UserManagement({ ...u, businessObj: buisnessObj }),
			EmailNotificationSettings: (n) =>
				AppRoute.EmailNotificationSettings({
					...n,
					businessObj: buisnessObj,
				}),
				MCCAccessContactInfo: (s) =>
				AppRoute.MCCAccessContactInfo({
					...s,
					businessObj: buisnessObj,
				}),
			Permissions: (p) =>
				AppRoute.Permissions({
					...p,
					businessObj: buisnessObj,
				}),
		});
	}
	GetBusinessObj(): Opt<BusinessObj> {
		return opt.FromNullable(this.Data.businessObj);
	}
}

export const Upload = AppRoute.Upload({
	path: appPath.Upload(),
	Component: UploadComponent,
	id: businessObjType.CreateBusinessObjType(OBJECT_ID_CREATE_CONTAINMENT),
	requiredPerms: [],
});

export const Dashboard = AppRoute.Dashboard({
	path: appPath.Home(),
	Component: DashboardComponent,
	id: businessObjType.CreateBusinessObjType(OBJECT_ID_CREATE_CONTAINMENT),
	requiredPerms: [],
});

export const UserManagement = AppRoute.UserManagement({
	path: appPath.UserManagement(),
	Component: UserManagementComponent,
	id: businessObjType.CreateBusinessObjType(OBJECT_ID_MANAGE_USER),
	requiredPerms: [],
});

export const Download = AppRoute.Download({
	path: appPath.Download(),
	Component: DownloadPage,
	id: businessObjType.CreateBusinessObjType(OBJECT_ID_CREATE_CONTAINMENT),
	requiredPerms: [],
	hidden: true,
});

export const EmailNotificationSettingsRoute = AppRoute.EmailNotificationSettings({
	path: appPath.EmailNotificationSettings(),
	Component: EmailNotificationSettings,
	id: businessObjType.CreateBusinessObjType(OBJECT_ID_CREATE_CONTAINMENT),
	requiredPerms: [],
});

export const MCCAccessContactInfoRoute = AppRoute.MCCAccessContactInfo({
	path: appPath.MCCAccessContactInfo(),
	Component: MCCAccessContactInfoPage,
	id: businessObjType.CreateBusinessObjType(OBJECT_ID_CREATE_CONTAINMENT),
	requiredPerms: [],
	hidden: true,
});

export const PermissionsRoute = AppRoute.Permissions({
	path: appPath.Permissions(),
	Component: Permissions,
	id: businessObjType.CreateBusinessObjType(OBJECT_ID_CREATE_CONTAINMENT),
	requiredPerms: [],
});

export const AppRoutes = enm.New([
	Dashboard,
	Upload,
	Download,
	UserManagement,
	EmailNotificationSettingsRoute,
	MCCAccessContactInfoRoute,
	PermissionsRoute,
]);

export type AppRoutes = typeof AppRoutes;
